import React from 'react'

import { PageRender } from 'components/PageRender'
import { useAppInfo } from 'hooks/useAppInfo'
import { useUserSegmentation } from 'hooks/useUserSegmentation'
import { openDeeplink } from 'utils/helpers'

import * as S from '../styles'

export const IaSupport = () => {
  const { userSegmentation, pageStatus } = useUserSegmentation()

  const {
    languageDictionary: { support: dictionary },
  } = useAppInfo()

  return (
    <PageRender pageStatus={pageStatus}>
      <S.SupportContainer>
        <S.SupportCard>
          <S.SupportTitle>{dictionary.whatsAppTitle}</S.SupportTitle>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.whatsAppContactDeepLink,
                  dictionary.whatsAppTitle,
                  userSegmentation,
                )
              }
            >
              {dictionary.whatsAppContact}
            </S.Contact>
          </S.ContactContainer>
        </S.SupportCard>

        <S.SupportCard>
          <S.SupportTitle>{dictionary.emailTitle}</S.SupportTitle>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.emailContactDeepLink,
                  dictionary.emailTitle,
                  userSegmentation,
                )
              }
            >
              {dictionary.emailContact}
            </S.Contact>
          </S.ContactContainer>
        </S.SupportCard>

        <S.SupportCard>
          <S.SupportTitle>{dictionary.relationshipCenterTitle}</S.SupportTitle>
          <S.SupportInfo>{dictionary.relationshipCenterDescription}</S.SupportInfo>
          <S.ContactContainer>
            <S.Contact
              onClick={() =>
                openDeeplink(
                  dictionary.relationshipCenterContactDeeplink,
                  dictionary.relationshipCenterTitle,
                  userSegmentation,
                )
              }
            >
              {dictionary.relationshipCenterContact}
            </S.Contact>
          </S.ContactContainer>
        </S.SupportCard>
      </S.SupportContainer>
    </PageRender>
  )
}
